(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-bp-help]').forEach(root => {
      if (root.dataset.helpReady) return;
      root.dataset.helpReady = 'true';
      const gallery = root.matches('[data-gallery]') ? root : null;
      if (gallery) {
        const cards = [...gallery.querySelectorAll('[data-gallery-card]')];
        const filters = [...gallery.querySelectorAll('[data-gallery-filter]')];
        const more = gallery.querySelector('[data-gallery-more]');
        const count = gallery.querySelector('[data-gallery-count]');
        const dialog = gallery.querySelector('[data-gallery-dialog]');
        let category = 'all', limit = 12, matched = cards, active = 0, returnFocus;
        const update = () => {
          matched = cards.filter(card => category === 'all' || card.dataset.category === category);
          cards.forEach(card => card.hidden = !matched.includes(card) || matched.indexOf(card) >= limit);
          filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.galleryFilter === category)));
          count.textContent = count.dataset.countTemplate.replace('[count]', matched.length);
          more.hidden = matched.length <= limit;
          gallery.querySelector('[data-gallery-empty]').hidden = matched.length > 0;
        };
        gallery.querySelector('[data-gallery-controls]').hidden = false;
        filters.forEach(button => {
          if (button.dataset.galleryFilter !== 'all' && !cards.some(card => card.dataset.category === button.dataset.galleryFilter)) button.hidden = true;
          button.addEventListener('click', () => { category = button.dataset.galleryFilter; limit = 12; update(); });
        });
        more.addEventListener('click', () => { const firstNew = matched[limit]; limit += 12; update(); firstNew?.querySelector('a')?.focus({preventScroll: true}); });
        const show = index => {
          active = (index + matched.length) % matched.length;
          const link = matched[active].querySelector('[data-gallery-open]');
          const picture = dialog.querySelector('[data-gallery-image]');
          picture.src = link.href;
          picture.alt = link.querySelector('img').alt;
          dialog.querySelector('#ProjectPhotoTitle').textContent = link.dataset.title;
          dialog.querySelector('[data-gallery-caption]').textContent = link.dataset.caption;
          dialog.querySelector('[data-gallery-category]').textContent = link.dataset.categoryLabel;
          dialog.querySelector('[data-gallery-position]').textContent = `${active + 1} / ${matched.length}`;
          const enquiry = dialog.querySelector('[data-gallery-enquire]');
          const enquiryUrl = new URL(enquiry.href, location.origin);
          enquiryUrl.searchParams.set('topic', ['equipment', 'fleet'].includes(matched[active].dataset.category) ? 'fleet' : 'custom');
          enquiryUrl.searchParams.set('project', link.dataset.title);
          enquiry.href = enquiryUrl.pathname + enquiryUrl.search;
          const shop = dialog.querySelector('[data-gallery-shop]');
          shop.hidden = !link.dataset.shop;
          if (link.dataset.shop) shop.href = link.dataset.shop;
          dialog.querySelector('[data-gallery-prev]').disabled = matched.length < 2;
          dialog.querySelector('[data-gallery-next]').disabled = matched.length < 2;
        };
        cards.forEach(card => card.querySelector('[data-gallery-open]').addEventListener('click', event => {
          if (typeof dialog.showModal !== 'function' || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault(); returnFocus = event.currentTarget; show(matched.indexOf(card)); dialog.showModal(); document.documentElement.classList.add('bp-gallery-open');
        }));
        dialog.querySelector('[data-gallery-close]').addEventListener('click', () => dialog.close());
        dialog.querySelector('[data-gallery-prev]').addEventListener('click', () => show(active - 1));
        dialog.querySelector('[data-gallery-next]').addEventListener('click', () => show(active + 1));
        dialog.addEventListener('click', event => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close(); } });
        dialog.addEventListener('keydown', event => { if (event.key === 'ArrowRight') { event.preventDefault(); show(active + 1); } if (event.key === 'ArrowLeft') { event.preventDefault(); show(active - 1); } });
        dialog.addEventListener('close', () => { document.documentElement.classList.remove('bp-gallery-open'); returnFocus?.focus({preventScroll: true}); });
        update();
      }
      const faq = root.querySelector('[data-faq]');
      if (faq) {
        const search = faq.querySelector('[data-faq-search]'), items = [...faq.querySelectorAll('[data-faq-item]')];
        const groups = [...faq.querySelectorAll('[data-faq-group]')], clear = faq.querySelector('[data-faq-clear]');
        faq.querySelector('[data-faq-search-wrap]').hidden = false;
        const update = () => {
          const terms = search.value.toLocaleLowerCase().trim().split(/\s+/).filter(Boolean);
          let count = 0;
          items.forEach(item => { const match = terms.every(term => item.textContent.toLocaleLowerCase().includes(term)); item.hidden = !match; if (terms.length) item.open = match; else item.open = false; if (match) count++; });
          groups.forEach(group => group.hidden = ![...group.querySelectorAll('[data-faq-item]')].some(item => !item.hidden));
          faq.querySelector('[data-faq-empty]').hidden = count > 0;
          const status = faq.querySelector('[data-faq-count]'); status.textContent = terms.length ? status.dataset.countTemplate.replace('[count]', count) : '';
          clear.hidden = !terms.length;
        };
        search.addEventListener('input', update);
        clear.addEventListener('click', () => { search.value = ''; update(); search.focus(); });
        faq.querySelectorAll('.bp-help-side-nav a[href^="#faq-"]').forEach(link => link.addEventListener('click', () => { search.value = ''; update(); }));
      }
      const checklist = root.querySelector('[data-install-checklist]');
      if (checklist) {
        const boxes = [...checklist.querySelectorAll('[data-install-check]')], key = 'bp-install-checklist-v1';
        try { const saved = JSON.parse(localStorage.getItem(key) || '[]'); if (Array.isArray(saved)) boxes.forEach(box => box.checked = saved.includes(box.dataset.installCheck)); } catch (_) {}
        const update = () => { const checked = boxes.filter(box => box.checked).map(box => box.dataset.installCheck); const progress = checklist.querySelector('[data-install-progress]'); progress.textContent = progress.dataset.countTemplate.replace('[count]', checked.length); try { localStorage.setItem(key, JSON.stringify(checked)); } catch (_) {} };
        boxes.forEach(box => box.addEventListener('change', update));
        const reset = checklist.querySelector('[data-install-reset]'); reset.hidden = false; reset.addEventListener('click', () => { boxes.forEach(box => box.checked = false); update(); });
        const print = root.querySelector('[data-help-print]'); print.hidden = false; print.addEventListener('click', () => window.print()); update();
      }
      const topic = root.querySelector('[data-project-topic]');
      if (topic) {
        const params = new URLSearchParams(location.search);
        const option = [...topic.options].find(option => option.dataset.topic === params.get('topic'));
        if (option) topic.value = option.value;
        const project = params.get('project');
        if (project) root.querySelector('[data-project-reference]').value = project.slice(0, 200);
        root.querySelector('[data-contact-success]')?.focus();
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

